<template>
    <div class="popup visible" id="human-questionnaire-popup" @click.stop="">
        <pre-loader-component :visible="loading"></pre-loader-component>
        <div class="max-w-content" v-if="!loading">
            <p class="box-title center">Анкета</p>
            <div class="completed-questionnaire-view">
                <questionnaire-list :view-mode="true" v-for="(list,index) in lists" :list=list
                                    class="questionnaire-form-box" :key="index"
                                    :answers="answers"></questionnaire-list>
            </div>
            <div class="center">
                <span @click="$emit('up-click')" title="Наверх" class="js-scroll-to-top"><span>
                    <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-up/></icon-base>
                    Наверх
                </span></span>
            </div>
            <span v-show="!loading" class="js-close-popup" title="Закрыть" @click="$emit('close')">
                <icon-base width="14" height="14" viewBox="0 0 14 14"><icon-close/></icon-base>
            </span>
        </div>
    </div>

</template>

<script>

    import {mapActions, mapState} from 'vuex'
    import QuestionnaireList from "../Questionnaire/QuestionnaireList";
    import PreLoaderComponent from "../common/PreLoader";
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";
    import IconArrowUp from "../common/icons/IconArrowUp";
    export default {
        name: 'questionnaire-view',
        components: {
            IconArrowUp,
            IconClose,
            IconBase,
            PreLoaderComponent,
            QuestionnaireList,
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState({
                lists: state => state.people.lists,
                answers: state => state.people.answers,
            }),
        },
        props: {
        },
        methods: {
            ...mapActions('people',[
                'getQuestions'
            ]),
            handleScrollTop() {
               this.emit('scrollTop');
            }
        },
        created() {
            this.getQuestions().then(() => {
                this.loading = false;
            })
        }
    }
</script>

<style scoped>

</style>
